import { ITableColumn } from '@makyoapp/makyo-sdk/models/Table'

import { Cell, ICell } from '.'

export interface IAttachment extends ITableColumn {
  Settings: null
}

export interface IAttachmentCell extends ICell {
  fileName: any
  settings: null
}

export class AttachmentCell implements IAttachmentCell {
  value: Cell
  settings: null

  constructor(value: Cell, settings: null) {
    this.value = value
    this.settings = settings
  }

  toString(): string {
    // Handle different types of value and convert them to string
    if (this.value === null) {
      return ''
    }

    if (typeof this.value === 'number' || typeof this.value === 'boolean') {
      return String(this.value)
    }

    if (this.value instanceof Date) {
      return this.value.toISOString() // Convert Date to ISO string
    }

    return String(this.value) // Fallback for string type
  }

  toCell<T extends Cell>(newValue: T) {
    // If the value is undefined or invalid, we could return a default
    if (newValue === undefined || newValue === null || typeof newValue !== 'string') {
      this.value = ''
      return this
    }

    this.value = newValue
    return this
  }

  get fileName() {
    return getFileName(this.value)
  }
}

export function getFileName(value: any) {
  // return the last part of the URL urldecoded
  if (typeof value !== 'string' || !value) return ''

  return decodeURIComponent(value.toString()?.split('/').pop() || '')
}
